/**
 * Part of ankecare project.
 *
 * @copyright  Copyright (C) 2021 __ORGANIZATION__.
 * @license    __LICENSE__
 */

const collapseBlock = $('.j-checkbox-collapse');
const checkboxes = $('.form-check-input');

collapseBlock.on('show.bs.collapse', (e) => {
  e.stopPropagation();

  let $this = $(e.currentTarget);
  $this.prev().find('i').removeClass('fa-angle-down');
  $this.prev().find('i').addClass('fa-angle-up');
});

collapseBlock.on('hide.bs.collapse', (e) => {
  e.stopPropagation();

  let $this = $(e.currentTarget);

  $this.prev().find('i').removeClass('fa-angle-up');
  $this.prev().find('i').addClass('fa-angle-down');
});

checkboxes.on('change', function () {
  $(this).parent().parent().siblings('.collapse').find('input').prop('checked', this.checked);
});

checkboxes.each((i, e) => {
  let input = $(e);

  if (input[0].checked) {
    let collapse = input.parents('.j-checkbox-collapse');

    if (!collapse.hasClass('show')) {
      collapse.addClass('show');

      let icon = collapse.prev().find('i');

      icon.removeClass('fa-angle-down');
      icon.addClass('fa-angle-up');
    }
  }
});
